
const baseUserUrl = "User"

  const endpoints = {
   getInvoiceList:`${baseUserUrl}/GetUserPurchaseList`,
   getInvoiceDetails:`${baseUserUrl}/GetUserPurchaseDetail`,
  };
  
  export default endpoints;